import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// CP-001: read-only list of the six one-time data changes and whether they ran on THIS database.
export const DataChangesStatus = ({ open }) => {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  const load = () => { setErr(""); api.get("/admin/data-changes").then((r) => setD(r.data)).catch((e) => setErr(errMsg(e))); };
  useEffect(() => { if (open) load(); }, [open]);
  const when = (t) => (t ? new Date(t).toLocaleString() : "");
  return (
    <section className="lg-card" style={{ padding: 14, marginTop: 16 }} data-testid="data-changes-status">
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
        <div className="lg-eyebrow" style={{ marginRight: "auto" }}>One-time data changes (read-only)</div>
        <button className="lg-btn ghost sm" onClick={load} data-testid="data-changes-refresh"><RefreshCw size={13} /></button>
      </div>
      <p style={{ fontSize: 12, color: "var(--muted)", margin: "0 0 10px" }}>
        These no longer run when the site starts or is published. This list only shows what has already run on this database.
      </p>
      {err && <p style={{ color: "var(--danger)" }} data-testid="data-changes-error">{err}</p>}
      {!d && !err && <p>Loading…</p>}
      {d && (
        <>
          <p style={{ fontSize: 12, margin: "0 0 10px" }} data-testid="data-changes-db">
            Database <b>{d.database}</b> · {Object.entries(d.counts).map(([k, v]) => `${k} ${v}`).join(" · ")} · checked {when(d.checkedAt)}
          </p>
          {d.changes.map((c) => (
            <div key={c.id} style={{ padding: "8px 0", borderTop: "1px solid var(--border)" }} data-testid={`data-change-${c.id}`}>
              <div style={{ display: "flex", gap: 8, alignItems: "baseline" }}>
                <b style={{ color: c.applied ? "var(--good)" : "var(--muted)" }} data-testid={`data-change-state-${c.id}`}>
                  {c.applied ? "✓ Ran" : "○ Not run"}
                </b>
                <span style={{ fontSize: 13 }}>{c.title}</span>
              </div>
              <div style={{ fontSize: 11, color: "var(--muted)" }}>
                {c.id}
                {c.applied && ` · ${when(c.appliedAt)}`}
                {c.applied && Object.keys(c.result).length > 0 && ` · ${Object.entries(c.result).map(([k, v]) => `${k}: ${v}`).join(", ")}`}
                {c.applied && (c.backupTaken ? " · backup kept" : " · no backup")}
              </div>
            </div>
          ))}
        </>
      )}
    </section>
  );
};
